import Text from 'components/elements/text';
import { FullContainer, SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

// import GuestTable from './tables/guest-table';
import ProductVariantTable from './tables/product-variant-table';

export default function ProductDetailField() {
  const { t } = useTranslation();
  return (
    <FullContainer>
      <Text variant="HeadingXSmall">{t('common:product_details')}</Text>
      <SeparatorVertical $margin={36} />
      {/* <GuestTable /> */}
      <SeparatorVertical $margin={36} />
      <ProductVariantTable />
    </FullContainer>
  );
}
